const numberFormatRegex = /\B(?=(\d{3})+(?!\d))/g

export const numberFormat = (num: number) => `${num}`.replace(numberFormatRegex, ',')
